import Hero from '../../components/Hero/Hero';
import Services from '../../components/Services/Services';
import Sap from '../../components/Sap/Sap';
import Faq from '../../components/Faq/Faq';
import Contact from '../../components/Contact/Contact';

const Home = () => {
  return (
    <>
      <main>
          <Hero />
          <Services />
          <Sap />
          <Faq />
          <Contact />
      </main>
    </>
  );
};

export default Home;